import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
    Button,
    FormGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import TimesheetContractPhaseButton from './TimesheetContractPhaseButton';
import { FormLabel } from '@mui/material';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { addClientTimesheetContractPhaseAdjustmentSafe } from './CrewTimesheet';

export default class PhaseCodeManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false, additionalContractPhaseCodeIds: [] };

        this.toggleModal = this.toggleModal.bind(this);
        this.onAdditionalContractPhaseSelect =
            this.onAdditionalContractPhaseSelect.bind(this);
    }

    toggleModal() {
        const { showModal } = this.state;
        this.setState({ showModal: !showModal });
    }

    getUnselectedPhaseCodes() {
        const { timesheet, job } = this.props;

        return job.contract.contractPhases.filter(
            (cp) =>
                !timesheet.timesheetContractPhases.some(
                    (tcp) => tcp.contractPhaseId == cp.id
                )
        );
    }

    onAdminContractPhaseChange = () => {
        const { additionalContractPhaseCodeIds } = this.state;
        const { timesheet, job, isAdmin } = this.props;

        if (!isAdmin) {
            throw new Error('Non-admin invoked onAdminContractPhaseChange.');
        }

        additionalContractPhaseCodeIds
            .filter(
                (cpi) =>
                    !timesheet.timesheetContractPhases.some(
                        (tcp) => tcp.contractPhaseId == cpi
                    ) &&
                    !timesheet.timesheetContractPhaseAdjustments.some(
                        (tcpa) => tcpa.contractPhaseId == cpi
                    )
            )
            .forEach((cpi) => {
                addClientTimesheetContractPhaseAdjustmentSafe(
                    timesheet,
                    job,
                    cpi
                );
            });
    };

    onFieldUserContractPhaseChange = () => {
        const { additionalContractPhaseCodeIds } = this.state;
        const { timesheet, job } = this.props;

        additionalContractPhaseCodeIds
            .filter(
                (cpi) =>
                    !timesheet.timesheetContractPhases.some(
                        (tcp) => tcp.contractPhaseId == cpi
                    )
            )
            .forEach((cpi) => {
                const contractPhase = job.contract.contractPhases.find(
                    (cp) => cp.id == cpi
                );

                const timesheetPhaseMaterials =
                    contractPhase.phaseMaterials.map((pm) => {
                        return {
                            phaseMaterialId: pm.id,
                            received: 0,
                            quantity: 0,
                        };
                    });

                timesheet.timesheetContractPhases.push({
                    contractPhaseId: cpi,
                    quantity: 0,
                    timeSpent: 0,
                    timesheetId: timesheet.id,
                    timesheetPhaseMaterials,
                    isFieldUserAdded: true,
                });

                timesheet.timesheetDetails.forEach((td) => {
                    td.timesheetDetailContractPhases.push({
                        timesheetDetailId: td.id,
                        contractPhaseId: cpi,
                        quantity: 0,
                    });
                });
            });
    };

    applyContractPhaseChange = () => {
        const { timesheet, isAdmin, onTimesheetMutated } = this.props;

        if (isAdmin) {
            this.onAdminContractPhaseChange();
        } else {
            this.onFieldUserContractPhaseChange();
        }

        onTimesheetMutated(timesheet);

        this.setState({ additionalContractPhaseCodeIds: [], showModal: false });
    };

    onAdditionalContractPhaseSelect(contractPhaseSelections) {
        const additionalContractPhaseCodeIds =
            contractPhaseSelections && contractPhaseSelections.length
                ? contractPhaseSelections.map((cp) => cp.id)
                : [];

        this.setState({ additionalContractPhaseCodeIds });
    }

    render() {
        const { timesheet, isReadOnly } = this.props;

        if (!timesheet) {
            return null;
        }

        const { showModal, additionalContractPhaseCodeIds } = this.state;

        const unselectedPhaseCodes = this.getUnselectedPhaseCodes();

        const noNewPhaseSelections = additionalContractPhaseCodeIds.length == 0;
        const buttonColor = noNewPhaseSelections ? 'default' : 'success';

        return (
            <>
                {timesheet.timesheetContractPhases.map((tcp) => {
                    const timesheetContractPhaseAdjustment =
                        timesheet.timesheetContractPhaseAdjustments.find(
                            (tcpa) => tcpa.timesheetContractPhaseId == tcp.id
                        );

                    return (
                        <TimesheetContractPhaseButton
                            key={`tcpbm-${tcp.contractPhaseId}-${tcp.id}`}
                            timesheetContractPhase={tcp}
                            timesheetContractPhaseAdjustment={
                                timesheetContractPhaseAdjustment
                            }
                            {...this.props}
                        />
                    );
                })}

                {timesheet.timesheetContractPhaseAdjustments
                    .filter(
                        (tcpa) =>
                            !timesheet.timesheetContractPhases.some(
                                (tcp) => tcpa.timesheetContractPhaseId == tcp.id
                            )
                    )
                    .map((tcpa) => (
                        <TimesheetContractPhaseButton
                            key={`tcpabm-${tcpa.contractPhaseId}-${tcpa.id}`}
                            timesheetContractPhase={null}
                            timesheetContractPhaseAdjustment={tcpa}
                            {...this.props}
                        />
                    ))}

                <div className="grid-col">
                    <Button
                        type="button"
                        outline
                        className="add-phase-code"
                        hidden={unselectedPhaseCodes.length <= 0 || isReadOnly}
                        onClick={this.toggleModal}
                        size="sm"
                    >
                        <h1 className="text-success">
                            <FontAwesomeIcon icon={faPlusCircle} />
                        </h1>
                        <div className="text-muted">Add Phase Code</div>
                    </Button>

                    <Modal isOpen={showModal} size="xl">
                        <ModalHeader toggle={this.toggleModal}>
                            Add Phase Code(s)
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <FormLabel
                                    htmlFor="additionalPhaseCodes"
                                    text="Additional Phase Codes"
                                />
                                <ValidatedSelect
                                    id="additionalPhaseCodes"
                                    isMulti={true}
                                    options={unselectedPhaseCodes}
                                    getOptionValue={(cpc) => cpc.id}
                                    getOptionLabel={(cpc) =>
                                        `${cpc.displayPhase} - ${cpc.description}`
                                    }
                                    onChange={
                                        this.onAdditionalContractPhaseSelect
                                    }
                                />
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                type="button"
                                color={buttonColor}
                                disabled={noNewPhaseSelections}
                                onClick={this.applyContractPhaseChange}
                            >
                                {noNewPhaseSelections && (
                                    <>No additional phase selections</>
                                )}

                                {!noNewPhaseSelections && (
                                    <>
                                        <FontAwesomeIcon
                                            icon={faPlusCircle}
                                            className="mr-2"
                                        />{' '}
                                        Add{' '}
                                        {additionalContractPhaseCodeIds.length}{' '}
                                        phase codes
                                    </>
                                )}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </>
        );
    }
}
